// extracted by mini-css-extract-plugin
export default {"top-notification-bar":"TopNotificationBar_top-notification-bar__ik7zl"};